import React, { useState } from 'react';
import '../css/registerwebinardetailspage.css';

const RegisterWebinarDetailsPage = () => {
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  return (
    <div className="webinar-container">
      <div className="webinar-info">
        <h2 className="webinar-heading">
          <span style={{ color: "#192437" }}>Register Now for Our </span>
          <span style={{ color: "#F5A526" }}>Upcoming Webinar</span>
        </h2>
        <p className="webinar-text">
          Join our exclusive webinar designed to help you stay informed about the latest industry trends, expert insights, and actionable strategies.
          <strong> Don’t miss this opportunity</strong> to grow your knowledge and connect with industry leaders.
        </p>

        <h2 className="webinar-subheading">
          <span style={{ color: "#192437" }}>Why </span>
          <span style={{ color: "#F5A526" }}>Attend?</span>
        </h2>
        <ul className="webinar-benefits">
          <li className="webinar-points"><strong>Expert Speakers:</strong> Hear directly from seasoned professionals.</li>
          <li className="webinar-points"><strong>Interactive Q&A:</strong> Get your questions answered in real-time.</li>
          <li className="webinar-points"><strong>Free Resources:</strong> Receive valuable material post-event.</li>
          <li className="webinar-points"><strong>Certificate of Attendance:</strong> Earn a certificate to showcase your learning.</li>
        </ul>

        <p className="webinar-text spaced-text">
          Ready to expand your knowledge? <strong>Fill out the form</strong> to reserve your seat today.
        </p>
      </div>

      <div className="webinar-form-div">
        <h4 className="webinar-form-heading">
          <span style={{ color: "#FFF" }}>Secure Your Spot For the </span>
          <span style={{ color: "#F5A526" }}>Live Webinar</span>
        </h4>

        <form onSubmit={(e) => { e.preventDefault(); setIsFormSubmitted(true); }}>
          <div className="bottom-form-row">
            <div>
              <label>Full Name</label>
              <input type="text" placeholder="Enter your name" required />
            </div>
            <div>
              <label>Email ID</label>
              <input type="email" placeholder="Enter your email" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Mobile No</label>
              <input type="tel" placeholder="Enter your mobile number" required />
            </div>
            <div>
              <label>Preferred Date</label>
              <input type="date" required />
            </div>
          </div>

          <div className="bottom-form-row">
            <div>
              <label>Preferred Time</label>
              <input type="time" required />
            </div>
            <div>
              <label>Upload Your Resume (Optional)</label>
              <input type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" />
            </div>
          </div>

          <button type="submit" className="webinar-submit-btn">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default RegisterWebinarDetailsPage;
